module.exports = __webpack_public_path__ + "static/media/FANTOM.d4c62fe1.png";